import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _PRIVACY_SETTINGS_SCH, _PRIVACY_SETTINGS_API;
import { toUpperCase } from './helpers/string';
var manageUserPrivacySettingsKeys = ['name', 'nickname', 'zoneinfo', 'picture', 'email', 'phoneNumber', 'jobTitle', 'organization', 'department', 'location'];
var schemaKeys = {
  name: 'name',
  nickname: 'nickname',
  zoneinfo: 'zoneinfo',
  picture: 'picture',
  email: 'email',
  phoneNumber: 'phoneNumber',
  jobTitle: 'jobTitle',
  organization: 'organization',
  department: 'department',
  location: 'location'
};
var apiKeys = {
  name: 'name',
  nickname: 'nickname',
  zoneinfo: 'zoneinfo',
  picture: 'picture',
  email: 'email',
  phoneNumber: 'extended_profile.phone_number',
  jobTitle: 'extended_profile.job_title',
  organization: 'extended_profile.organization',
  department: 'extended_profile.department',
  location: 'extended_profile.location'
};
export var PRIVACY_SETTINGS_SCHEMA_TO_API_MAP = (_PRIVACY_SETTINGS_SCH = {}, _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.name, apiKeys.name), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.nickname, apiKeys.nickname), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.zoneinfo, apiKeys.zoneinfo), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.picture, apiKeys.picture), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.email, apiKeys.email), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.phoneNumber, apiKeys.phoneNumber), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.jobTitle, apiKeys.jobTitle), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.organization, apiKeys.organization), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.department, apiKeys.department), _defineProperty(_PRIVACY_SETTINGS_SCH, schemaKeys.location, apiKeys.location), _PRIVACY_SETTINGS_SCH);

/**
 * Convert shape used to communicate with privacy APIs to shape that is used within our app.
 */
export var transformPrivacySettingsFormatFromApiToSchema = function transformPrivacySettingsFormatFromApiToSchema(data) {
  return Object.keys(PRIVACY_SETTINGS_SCHEMA_TO_API_MAP).reduce(function (memo, schemaValue) {
    var apiResponseKey = PRIVACY_SETTINGS_SCHEMA_TO_API_MAP[schemaValue];
    var privacySetting = data[apiResponseKey];
    memo[schemaValue] = toUpperCase(privacySetting);
    return memo;
  }, {});
};
export var PRIVACY_SETTINGS_API_TO_SCHEMA_MAP = (_PRIVACY_SETTINGS_API = {}, _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.name, schemaKeys.name), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.nickname, schemaKeys.nickname), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.zoneinfo, schemaKeys.zoneinfo), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.picture, schemaKeys.picture), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.email, schemaKeys.email), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.phoneNumber, schemaKeys.phoneNumber), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.jobTitle, schemaKeys.jobTitle), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.organization, schemaKeys.organization), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.department, schemaKeys.department), _defineProperty(_PRIVACY_SETTINGS_API, apiKeys.location, schemaKeys.location), _PRIVACY_SETTINGS_API);

/**
 * Convert shape that is used within our app to shape used to communicate with privacy APIs.
 */

export var transformPrivacySettingsFormatFromSchemaToApi = function transformPrivacySettingsFormatFromSchemaToApi(data) {
  return Object.keys(PRIVACY_SETTINGS_API_TO_SCHEMA_MAP).reduce(function (memo, apiValue) {
    var apiResponseKey = PRIVACY_SETTINGS_API_TO_SCHEMA_MAP[apiValue];
    var privacySetting = data[apiResponseKey];
    if (privacySetting) {
      memo[apiValue] = privacySetting.toLowerCase();
    }
    return memo;
  }, {});
};